Whether previously delivered events should be included in the request.

This also includes events that were not delivered because the relevant hirer relationship or webhook subscription was not in place at time of occurrence.
